import { CommonModule } from '@angular/common';
import {
  Component,
  Input,
  OnInit,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import {
  GridAccordion,
  GridLibAngularComponentModule,
} from '@gen-nexus-registry/grid-lib-angular/dist/grid-lib-angular-component';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { ESectionTitle } from 'src/model/enum/sic-ania/section.title.enum';
import { EFormFieldSize } from 'src/model/enum/sic-ania/form-fields.enum';
import { StaticAccordionDataComponent } from '../shared-components/static-accordion-data/static-accordion-data.component';
import { IAtrcAttestati, IAtrcAttestatoSelect, IAtrcDetailResponse } from 'src/model/responses/sic-ania/atrc.response';
import {
  ISiviDetailResponse,
  ISiviEmission,
} from 'src/model/responses/sic-ania/sivi.response';
import {
  ICopertura,
  ISitaLastResponse,
} from 'src/model/responses/sic-ania/sita.response';
import { IDropdownConfig } from '../interfaces/form-fields.interface';
import { UtilityService } from 'src/api/utility.service';
import { LABEL_KEY, VALUE_KEY } from 'src/model/constants/search.constants';
import {
  atrcSectionRows,
  sitaBusinessDetailsRows,
  sitaCoverageDetailsRows,
  siviSectionRows,
} from 'src/model/constants/constants';
import { DashboardService } from 'src/api/dashboard.service';
import { ISiviDetailMappedResponse } from '../interfaces/sivi.interface';
import { HttpErrorResponse } from '@angular/common/http';
import { ISitaDetailMappedResponse} from '../interfaces/sita.interface';
import { IAtrcDetailMappedResponse } from '../interfaces/atrc.interface';
import { GERAR_BOX_MAPPINGS } from 'src/model/constants/dashboard.constants';
import { EPropsToMap } from 'src/model/enum/sic-ania/props-to-map.enum';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-detail-accordion',
  templateUrl: './detail-accordion.component.html',
  standalone: true,
  imports: [
    GridLibAngularComponentModule,
    CommonModule,
    ReactiveFormsModule,
    TranslateModule,
    StaticAccordionDataComponent,
  ],
  styleUrls: ['./detail-accordion.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class DetailAccordionComponent implements OnInit {
  onDestroy$: Subject<void> = new Subject<void>();
  readonly labelKey = LABEL_KEY;
  readonly valueKey = VALUE_KEY;

  openModal = false;
  errorMessages: any[] = [];

  @Input()
  sectionTitle?: string;

  @Input()
  sectionData?: any;



  @ViewChild('accordion') accordion!: GridAccordion;
  accordionDataForm: FormGroup = new FormGroup({});
  dropDownOptionsArray: any = [];
  ultimoResponse: any;
  accordionDropConfig!: IDropdownConfig;
  options: string[] = [];
  columns: string[] = [];
  rows: any[] = [];
  dropDownValue: any;
  searchParams?: any;
  sectionRow: any[] = [];
  siviSectionRows:any[] = [];
  sitaBusinessDetailsRows:any[] = [];
  sitaCoverageDetailsRows:any[] = [];
  atrcSectionRows:any[] = [];
  hideSection = false;
  sectionRows:any;
  propertiesArray: string[][] = [];

  constructor(
    public utilityService: UtilityService,
    private dashboardService: DashboardService,
    private translate: TranslateService,
    private userService: UserService
  ) {}

  ngOnInit() {
    this.initForm(this.sectionData);
    this.options = this.sectionData.dropDownData;
  }

  removeEmptySection(sectionData: any, rowArray:any){
    const totalProperties: string[][] = [];
    this.resetPropertyArray(rowArray);
    rowArray.forEach((constantKey: any, index:number) => {
      const rows:any[] = []
      let rowsProperties: string[] = [];
      let count = 0
      constantKey.data.forEach((key: any) => {
        key.forEach((ele:any) => {
          rows.push(ele)
        })
      })
      rowsProperties = rows.map((ele) => ele.value);
      totalProperties.push(rowsProperties);
      rowsProperties.forEach((ele) => {
        if(ele !== EPropsToMap.STATE && ele !== EPropsToMap.PLATE){
          if(!sectionData[ele] || sectionData[ele] === '0001-01-01'){
            count++
          }
        }
      })
      if(count === rowsProperties.length){
        rowArray[index].hide = true;
      }
    }) 
    return totalProperties;
  }


  insertCoownerSectionInArray(sectionData:any, rowArray:any){
    const coowners = [];
    let max = 0;
    Object.keys(sectionData).forEach((key:any) => {
      if(key.includes('CMP')){
        const numPart = parseInt(key.substring(key.indexOf('CMP') + 'CMP'.length,key.length));
        if(numPart > max){
          max = numPart;
        }
      }
    })
    for(let i = 0; i< max; i++){
      coowners.push(this.utilityService.buildCoowner(i))
    }
    this.removeEmptySection(sectionData,coowners);
    rowArray = rowArray.slice(0,4).concat(coowners).concat(rowArray.slice(4,rowArray.length))
    return rowArray;
  }


  ngAfterViewInit(){
    if(Object.keys(this.sectionData.accordionData).length === 0){
      this.accordion.disabled = true;
    }
    this.utilityService.emitSectionTitleSubject.subscribe((sectionTitle) => {
      this.accordion.isOpen = !this.accordion.disabled && sectionTitle === this.sectionTitle;
    });
  }

  initTable(attestati: IAtrcAttestati[]) {
    if (attestati) {
      const attestato = attestati[0];
      this.columns = this.createColumns(attestato);
      attestati.forEach((attestato: IAtrcAttestati) => {
        this.rows.push(this.createRows(attestato));
      });
    }
  }

  createColumns(attestato: IAtrcAttestati) {
    const columns: any[] = [
      {
        key: 'a0Anno',
        value: '',
      },
    ];
    Object.keys(attestato).forEach((prop: string) => {
      if(prop.includes('Anno')){
        const anniDisponibili = attestato[prop as keyof IAtrcAttestati];
        columns.push({
          key: prop,
          value: anniDisponibili,
        });
      }
     })
   
    return columns;
  }

  createRows(attestato: IAtrcAttestati) {
    const attestatoMapped = this.utilityService.mapCodeToValue(attestato);
    const numSinProps:string[] = []
    const row: any = {
      a0Anno: attestatoMapped.tipologiaSinistri,
    };
    Object.keys(attestato).forEach((prop: string) => {
      if(prop.includes('Numsin')) numSinProps.push(prop);
    });
    numSinProps.forEach((prop:string, index:number) => {
      row['a' + (index + 1) + 'Anno'] = attestato[prop as keyof IAtrcAttestati];
    })
    return row;
  }

  setUndefinedProperties(response:any){
    this.propertiesArray.forEach((arr) => {
      arr.forEach((prop) => {
        response = {
          ...response,
          [prop]: response![prop as keyof ISiviDetailResponse]
        } as ISiviDetailResponse
      })
    })
    return response;
  }

  buildSiviDetail(response:ISiviDetailResponse | undefined){
    let dataOperazione;
    let oraOperazione;
    const datesPropsToConvert = ['dataInizCircCic', 'dataEmissione', 'dataImmatricolazione', 'dataPrimaImmatricolazione',
        'dataOperazione', 'dtOmologazione', 'dataAggOmol'];
    const numberPropsToConvert = ['cilindrata', 'potenza', 'velmax', 'lunga', 'larga', 'sbalzo', 'interasse1', 'interasse2', 'interasse3'];
    response = this.setUndefinedProperties(response) as ISiviDetailResponse; 
    if(response){
      const emissioni = this.sectionData.dropDownData.siviDropDownData.emissioni;
      emissioni?.forEach((emissione:ISiviEmission) => {
        if(emissione.dataEmissione === response?.dataEmissione){
          dataOperazione = emissione.dataOperazione;
          oraOperazione = emissione.oraOperazione;
        }
      })
    }
    response = {
      ...response,
      dataOperazione: dataOperazione,
      oraOperazione: oraOperazione,
    }
    const siviMappedResponse = this.utilityService.mapCodeToValue({
    ...response,
    ...this.convertDataFormat(response, datesPropsToConvert, 'date'),
    ...this.convertDataFormat(response, numberPropsToConvert, 'float'),
    targa: this.searchParams?.formIdVeic === 'L' ? response?.idVeicAlt : this.utilityService.setIdVeic(this.searchParams),
    idVeicAlt: this.searchParams?.formIdVeic === 'L' ? this.searchParams.idVeic : response?.idVeicAlt,
    nazione: response?.nazione ? (response?.nazione === 'E' ? 'Estera' : 'Italiana') : '',
    use: this.utilityService.getUseValue(response?.codCatuso),
    category: this.utilityService.getCategoryValue(response?.codCatuso),
    emissioneCo2: response?.emissioneCo2 ? (response?.emissioneCo2 as number / 10).toFixed(1) : '',
    tipoVeicoloLabel: response?.tipoVeicolo,
    tipoVeicoloMCTCLabel: response?.tipoVeicoloMCTC,
    tpCambio: GERAR_BOX_MAPPINGS.get(response?.tpCambio || ''),
    targaPrecedente: response?.targaPrec || response?.targaPrecedente
  } as ISiviDetailMappedResponse);
  this.sectionData = {
    ...this.sectionData,
    accordionData: {
    ...this.sectionData.accordionData,
    ...siviMappedResponse
  } as ISiviDetailMappedResponse }
  }

  buildSitaDetail(response:ISitaLastResponse | undefined){
    const datesPropsToConvert = [
      'dataIncasso',
      'dataLastAgg',
      'dataScadMora',
      'dataScadSosp',
      'effettoCopertura',
      'effettoPolizza',
      'scadenzaCopertura',
      'scadenzaPolizza',
    ];
    const hourPropsToConvert = [
      'oraScadCop',
      'oraEffCop',
    ];
      response = this.setUndefinedProperties(response); 
      this.utilityService.changePlateLabelIfPlateTypeIsChassis(sitaCoverageDetailsRows, this.searchParams)
      const sitaMappedResponse = this.utilityService.mapCodeToValue({
        ...response,
        ...this.convertDataFormat(response, datesPropsToConvert, 'date'),
        ...this.convertDataFormat(response, hourPropsToConvert, 'stringHour'),
        targa: this.utilityService.setIdVeic(this.searchParams!),
        ggesteCop: response!.ggesteCop ? parseInt(response!.ggesteCop) : '',
        impresaDbLabel: response?.impresaDb,
        tipoVeicoloLabel: response?.tipoVeicolo,
        tipoVeicoloMCTCLabel: response?.tipoVeicoloMCTC,
        canaleAggLabel: response?.canaleAgg,
        activity: this.translate.instant('DASHBOARD.DETAILED-DATA.ACTIVITY'),
        tipoPolizza: response?.tipoPolizza,
        modPagam: response?.modoPagam ? response.modoPagam : response?.modPagam,
        blackBox: response?.blackBox === '1' ? 'Presente' : 'Assente',
        datiCompleti: response?.datiCompleti === 'G' ? 'No' : 'Si',
        timeLastAgg: this.utilityService.convertStringTimestampToDate(response!.timeLastAgg, true)
      });
      sitaMappedResponse.impresaDb = sitaMappedResponse.impresaDb ? sitaMappedResponse.impresaDb + ' - ' + sitaMappedResponse.impresaDbLabel : '';
      sitaMappedResponse.tipoVeicolo = sitaMappedResponse.tipoVeicolo ? sitaMappedResponse.tipoVeicolo + ' - ' + sitaMappedResponse.tipoVeicoloLabel : '';
      sitaMappedResponse.tipoVeicoloMCTC = sitaMappedResponse.tipoVeicoloMCTC ? sitaMappedResponse.tipoVeicoloMCTC + ' - ' + sitaMappedResponse.tipoVeicoloMCTCLabel : '';
      sitaMappedResponse.canaleAgg = sitaMappedResponse.canaleAgg ? sitaMappedResponse.canaleAgg + ' - ' + sitaMappedResponse.canaleAggLabel : '';
      sitaMappedResponse.tipoMov = sitaMappedResponse.tipoMov && sitaMappedResponse.causMov ? sitaMappedResponse.tipoMov + ' - ' + sitaMappedResponse.causMov : 
        sitaMappedResponse.tipoMov || sitaMappedResponse.causMov ? sitaMappedResponse.tipoMov || sitaMappedResponse.causMov : '';
      this.sectionData = {
        ...this.sectionData,
        accordionData: {
          ...this.sectionData.accordionData,
          ...sitaMappedResponse
          } as ISitaDetailMappedResponse
        }
  }


  buildAtrcDetail(response:IAtrcDetailResponse | undefined){
    const datesPropsToConvert = ['dataScadContratto', 'dataFlussoIns', 'dataFlussoAgg'];
    const timestampsToConvert = ['timestampIns', 'timestampAgg'];
    response = this.setUndefinedProperties(response);
    this.utilityService.changePlateLabelIfPlateTypeIsChassis(atrcSectionRows, this.searchParams)
    const atrcMappedResponse = this.utilityService.mapCodeToValue({
      ...response,
      ...this.convertDataFormat(response, datesPropsToConvert, 'date'),
      ...this.convertDataFormat(response, timestampsToConvert, 'timestamp', true),
      targa: this.utilityService.setIdVeic(this.searchParams!),
      tipoVeicoloLabel:response?.tipoVeicolo,
      codImpCTPLabel: response?.codImpCTP ? response?.codImpCTP.toString() : '',
    });
    this.sectionData = {
      ...this.sectionData,
      accordionData: {
        ...this.sectionData.accordionData,
        ...atrcMappedResponse
        } as IAtrcDetailMappedResponse
      }
      this.columns = [];
      this.rows = [];
      this.initTable(response!.attestati);
  }

  resetPropertyArray(rowArray:any){
    rowArray = rowArray.map((section:any) => {
      if(section.hide){
         section.hide = false;
       }
       return section
     })
  }

  setPropertyArray(response:any,rowArray:any){      
    const propertyArray: any[] = [];
    rowArray = this.insertCoownerSectionInArray(response,rowArray);
    rowArray = rowArray.map((section:any) => {
      if(!section.hide){
        propertyArray.push(section)
      }
     })
     return propertyArray;
  }


  async setValue(value: any, formControlName: string) {
    const user = await this.userService.getUser();
    if (!formControlName) return;
    if (this.accordion && this.accordion.isOpen) {
      const control = this.accordionDataForm.get(formControlName);
      control?.setValue(value.target.value);
      this.dropDownValue = control?.value;
      let payload = {};
      this.errorMessages = [];
      switch (this.sectionTitle) {
        case ESectionTitle.SIVI:
          payload = {
            mode: "dettaglio-sivi",
            body: JSON.stringify({
              formIdVeic: this.utilityService.removeNumericValue(this.dropDownValue['formIdVeic']),
              idVeic: this.utilityService.setIdVeic(this.dropDownValue),
              codTpVeic: this.dropDownValue.tipoVeicolo,
              dataRiferimento: this.dropDownValue['dataRiferimento'],
              insTimestamp: new Date().toISOString(),
              idDenOperatore: user ? user['uid'] : '',
              ldapUsername: user ? user['uid'] : '',
              codAgenzia: user?.businessUnitId,
              denUtente: user?.nome.replace('\'',' ') + ' ' + user?.cognome.replace('\'',' '),
            })
          }
          this.dashboardService.postDetails(payload)
          .then((siviDetailResponse: ISiviDetailResponse | undefined) => {
            if (!siviDetailResponse) return;
            const siviStringifiedResponse = this.utilityService.parseStringifiedResponseInJSON(siviDetailResponse);
            const response = (siviStringifiedResponse as any).output['sivi-dettaglio']
            if(!response.error){
              this.removeEmptySection(response,siviSectionRows);
              this.siviSectionRows = this.setPropertyArray(response,siviSectionRows)
              this.buildSiviDetail(response);            
            }else{
              const errorResponse = siviStringifiedResponse; 
              this.openModal = true;
              this.utilityService.manageErrors(this.errorMessages,errorResponse);
            }
          }).catch((errorResponse: HttpErrorResponse) => {
            this.openModal = true;
            if (errorResponse) {
              this.errorMessages = [{ section: errorResponse.error.errorCode || '', messages: [errorResponse.error.errorMessage || ''] }]
              this.openModal = true;
            }
          })
          break;
        case ESectionTitle.SITA:
          payload = {
            mode: "dettaglio-sita",
            body: JSON.stringify({
              formIdVeic: this.utilityService.removeNumericValue(this.dropDownValue['formIdVeic']),
              idVeic: this.utilityService.setIdVeic(this.dropDownValue),
              tipoVeicolo: this.dropDownValue.tipoVeicolo,
              dataRiferimento: this.utilityService.addDaysToDate(this.dropDownValue['dataRiferimento'],1),
              oraRiferimento: this.dropDownValue['oraRiferimento'],
              insTimestamp: new Date().toISOString(),
              idDenOperatore: user ? user['uid'] : '',
              ldapUsername: user ? user['uid'] : '',
              codAgenzia: user?.businessUnitId,
              denUtente: user?.nome.replace('\'',' ') + ' ' + user?.cognome.replace('\'',' '),
            })
          }
          this.dashboardService.postDetails(payload)
          .then((sitaDetailResponse: ISitaLastResponse | undefined) => {
            if (!sitaDetailResponse) return;
            const sitaStringifiedResponse = this.utilityService.parseStringifiedResponseInJSON(sitaDetailResponse);
            const response = (sitaStringifiedResponse as any).output['sita-dettaglio']
            if(!response.error){
              const sitaTotalRows = sitaBusinessDetailsRows.concat(sitaCoverageDetailsRows)
              this.removeEmptySection(response,sitaTotalRows);
              this.sitaBusinessDetailsRows = this.setPropertyArray(response,sitaBusinessDetailsRows)
              this.sitaCoverageDetailsRows = this.setPropertyArray(response,sitaCoverageDetailsRows);
              this.buildSitaDetail(response);
            }else{
              const errorResponse = sitaStringifiedResponse; 
              this.openModal = true;
              this.utilityService.manageErrors(this.errorMessages,errorResponse);
            }
          }).catch((errorResponse: HttpErrorResponse) => {
            if (errorResponse) {
              this.errorMessages = [{ section: errorResponse.error.errorCode || '', messages: [errorResponse.error.errorMessage || ''] }]
              this.openModal = true;
            }
          })
          break;

          case ESectionTitle.ATRC:
          payload = {
            mode: "dettaglio-atrc",
            body: JSON.stringify({
              formIdVeic: this.utilityService.removeNumericValue(this.dropDownValue['formIdVeic']),
              idVeic: this.utilityService.setIdVeic(this.dropDownValue),
              tipoVeicolo: this.dropDownValue.tipoVeicolo,
              dataRiferimento: this.dropDownValue['dataRiferimento'],
              insTimestamp: new Date().toISOString(),
              idDenOperatore: user ? user['uid'] : '',
              ldapUsername: user ? user['uid'] : '',
              codAgenzia: user?.businessUnitId,
              denUtente: user?.nome.replace('\'',' ') + ' ' + user?.cognome.replace('\'',' '),
            })
          }
          this.dashboardService.postDetails(payload)
          .then((atrcDetailResponse: IAtrcDetailResponse | undefined) => {
            if (!atrcDetailResponse) return;
            const atrcStringifiedResponse = this.utilityService.parseStringifiedResponseInJSON(atrcDetailResponse);
            const response = (atrcStringifiedResponse as any).output['atrc-dettaglio']
            if(!response.error){
              this.removeEmptySection(response,atrcSectionRows);
              this.atrcSectionRows = this.setPropertyArray(response,atrcSectionRows);
              this.buildAtrcDetail(response);
            }else{
              const errorResponse = atrcStringifiedResponse; 
              this.openModal = true;
              this.utilityService.manageErrors(this.errorMessages,errorResponse);            }
          }).catch((errorResponse: HttpErrorResponse) => {
            if (errorResponse) {
              this.errorMessages = [{ section: errorResponse.error.errorCode || '', messages: [errorResponse.error.errorMessage || ''] }]
              this.openModal = true;
            }
          })
          break;
        default:
      }
      control?.updateValueAndValidity();
    }
  }

  convertDataFormat(
    response: any,
    propArray: string[],
    propType: string,
    showSeconds = false
  ) {
    let obj = {};
    const mappedArray = propArray.map((prop) => {
      let mappedProp;
      switch (propType) {
        case 'date':
          mappedProp = this.utilityService.convertYYYYMMDDInDDMMYYYY(
            response[prop]
          );
          break;
        case 'float':
          mappedProp = this.utilityService.setOneDecimalValueIfIsZero(
            response[prop]
          );
          break;
        case 'stringHour':
          mappedProp = this.utilityService.convertStringNumberInHour(
            response[prop]
          );
          break;
        case 'timestamp':
          mappedProp = this.utilityService.convertStringTimestampToDate(
            response[prop],
            showSeconds
          );
          break;
        default:
      }
      return mappedProp;
    });

    propArray.forEach((prop, index) => {
      obj = {
        ...obj,
        [prop]: mappedArray[index],
      };
    });

    return obj;
  }

  initForm(sectionData: any) {
    let accordionTitle!: string;
    switch (this.sectionTitle) {
      case ESectionTitle.SIVI:
        if(Object.entries(sectionData.accordionData).length){
          this.propertiesArray = this.removeEmptySection(sectionData.accordionData, siviSectionRows);
          this.siviSectionRows = this.setPropertyArray(sectionData.accordionData,siviSectionRows);
        }
        this.dropDownOptionsArray = sectionData.dropDownData[
          this.sectionTitle + 'DropDownData'
        ]?.emissioni as ISiviEmission[];
        this.ultimoResponse = sectionData.dropDownData[
          this.sectionTitle + 'Ultimo'
        ] as ISiviDetailResponse;
        this.accordionDataForm.addControl('siviDropDown', new FormControl());
        accordionTitle = ESectionTitle.SIVI;
        this.searchParams = sectionData.dropDownData.searchParams;
        break;
      case ESectionTitle.SITA:
        if(Object.entries(sectionData.accordionData).length){
          const sitaTotalRows = sitaBusinessDetailsRows.concat(sitaCoverageDetailsRows)
          this.propertiesArray = this.removeEmptySection(sectionData.accordionData, sitaTotalRows)
          this.sitaBusinessDetailsRows = this.setPropertyArray(sectionData.accordionData,sitaBusinessDetailsRows)
          this.sitaCoverageDetailsRows = this.setPropertyArray(sectionData.accordionData,sitaCoverageDetailsRows);
        }
        this.dropDownOptionsArray = sectionData.dropDownData[
          this.sectionTitle + 'DropDownData'
        ]?.coperture as ICopertura[];
        this.ultimoResponse = sectionData.dropDownData[
          this.sectionTitle + 'Ultimo'
        ] as ISitaLastResponse;
        this.accordionDataForm.addControl('sitaDropDown', new FormControl());
        accordionTitle = ESectionTitle.SITA;
        this.searchParams = sectionData.dropDownData.searchParams;
        break;
      case ESectionTitle.ATRC:
        if(Object.entries(sectionData.accordionData).length){
          this.propertiesArray = this.removeEmptySection(sectionData.accordionData, atrcSectionRows)
          this.atrcSectionRows = this.setPropertyArray(sectionData.accordionData,atrcSectionRows);
        }
        this.initTable(sectionData.accordionData.attestati);
        this.dropDownOptionsArray = sectionData.dropDownData[this.sectionTitle + 'DropDownData']?.attestati as IAtrcAttestatoSelect[];
        this.ultimoResponse = sectionData.dropDownData[this.sectionTitle + 'Ultimo'] as IAtrcDetailResponse;
        this.accordionDataForm.addControl('atrcDropDown', new FormControl());
        accordionTitle = ESectionTitle.ATRC;
        this.searchParams = sectionData.dropDownData.searchParams;
        break;
      default:
    }
    this.accordionDropConfig = this.setDropDownConfigs(accordionTitle);
  }

  mapOptionsFromBeResponse(value: any[]) {
    const options: any = [];
    let dataEmissione: string;
    let label: string;
    let optionValue = {};
    value?.forEach((element: any) => {
      if (this.sectionTitle === ESectionTitle.SIVI) {
        dataEmissione = element.dataEmissione;
        optionValue = {
          idVeic: this.searchParams?.idVeic,
          dataRiferimento: dataEmissione,
          tipoVeicolo: element.tipoVeicolo,
          formIdVeic: this.searchParams?.formIdVeic,
          codTpVeic: this.searchParams?.codTpVeic,
        };
        label =
          (dataEmissione || '') +
          ' ' +
          (element.oraOperazione || '') +
          ' ' +
          (element.idVeicAlt || '') +
          ' ' +
          (element.codiceFiscale || '');
      }
      if (this.sectionTitle === ESectionTitle.SITA) {
        dataEmissione = element.effettoCopertura;
        optionValue = {
          formIdVeic: this.searchParams?.formIdVeic,
          idVeic: this.searchParams?.idVeic,
          tipoVeicolo: element.tipoVeicolo,
          dataRiferimento: dataEmissione,
          oraRiferimento: '0000',
        };
        label =
          (element.impresaDb && dataEmissione ? element.impresaDb +
          ' - ' +
          dataEmissione : '') +
          ' ' +
          (element.oraEffettoCopertura && element.scadenzaCopertura ?
             element.oraEffettoCopertura +
          ' / ' +
          element.scadenzaCopertura: '') +
          ' ' +
          (element.oraScadCop || '');
      }
      if (this.sectionTitle === ESectionTitle.ATRC) {
        dataEmissione = element.scadenzaContratto;
        optionValue = {
          formIdVeic: this.searchParams?.formIdVeic,
          idVeic: this.searchParams?.idVeic,
          tipoVeicolo: element.tipoVeicolo,
          dataRiferimento: dataEmissione,
          codTpVeic: this.searchParams?.tipoVeicolo,
        };
        label =
          (dataEmissione || '') +
          ' ' +
          (element.idFiscContraente || '') +
          ' ' +
          (element.numPolizza || '');
      }
      
      options.push({
        value: optionValue,
        label: label,
      });
    });

    this.setDropdownFirstOption(options);
    return options;
  }

  setDropdownFirstOption(options: any) {
    const ultimo = this.ultimoResponse;
    options.forEach((option: any) => {
      if (
        option.value.dataRiferimento === ultimo.dataEmissione ||
        option.value.dataRiferimento === ultimo.dataScadContratto ||
        option.value.dataRiferimento === ultimo.effettoCopertura
      ) {
        this.accordionDataForm
          .get(this.sectionTitle + 'DropDown')
          ?.setValue(option.value);
      }
    });
  }

  setDropDownConfigs(accordionTitle: string) {
    return {
      form: this.accordionDataForm,
      formControlName: accordionTitle + 'DropDown',
      size: EFormFieldSize.MEDIUM,
      options: this.mapOptionsFromBeResponse(this.dropDownOptionsArray),
      optionLabel: this.labelKey,
      optionValue: this.valueKey,
      placeholder: 'selezionare un valore',
    };
  }
}
